/**
 * @file Defines the {@link @InterfaceButton} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling interface buttons
  */
  export class InterfaceButton {

    /**
     * Flag for whether click handler been added or not
     * @memberof InterfaceButton
     * @protected
     * @instance
     * @type {boolean}
     */
    _added

    /**
     * Reference to button node
     * @memberof InterfaceButton
     * @protected
     * @instance
     * @type {HTMLButtonElement}
     */
    _elem
    
    /**
     * Initialise interface button
     * @param {interface-button} b_ - Object containing ID and content of button
     */
    constructor(b_) {

        this.added = false                                                                         //Don't add click handler initially
        this._elem = document.getElementById(b_.id)                                                //Retrieve button node
        b_.translate ? this.elem.innerHTML = Translate.do(b_.text) : this.elem.innerHTML = b_.text //Set button text
        
    }

    /** Get added */ get added()   { return this._added }
    /** Set added */ set added(v_) { this._added = v_ }

    /** Get elem */ get elem() { return this._elem }

  }